module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp3_8023.454bef41.png";